const BACKEND_ENDPOINTS = {
  SIGNUP: "auth/signup",
  SIGNIN: "auth/login",
  WALLETBALANCE: "/wallet/balance",
  ADMIN_SIGNIN: "admin/login",
};

export { BACKEND_ENDPOINTS };
